export default function resetOnBfCache(
    node: HTMLElement,
    callback: () => void,
) {
    const handlePageShow = (event: PageTransitionEvent) => {
        if (event.persisted) {
            callback();
        }
    };

    window.addEventListener('pageshow', handlePageShow);

    return {
        destroy() {
            window.removeEventListener('pageshow', handlePageShow);
        },
    };
}
